import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isIsoDateString from 'common/util/isIsoDateString';
import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

import { SR_API_ACTION_PROPERTY_ATTRIBUTE_DELETE } from 'api/actionTypes';

import SrText from 'client/components/SrText';
import SrTable from 'client/components/SrTable';
import SrBox from 'client/components/SrBox';

import postWithState from 'client/actions/postWithState';

class SrTablePropertyAttributes extends Component {
  static propTypes = {
    propertyAttributes: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  _onDeletePropertyAttribute = (e) => {
    const { propertyAttributes, dispatch, onChange } = this.props;
    const propertyAttributeId = parseInt(e.target.dataset.id, 10);
    const propertyAttribute = propertyAttributes.find(({ id }) => id === propertyAttributeId);

    // eslint-disable-next-line max-len
    if (
      !global.confirm(
        `Are you sure you want to delete the property attribute "${propertyAttribute.name}"?`,
      )
    ) {
      return;
    }

    dispatch(postWithState, {
      action: SR_API_ACTION_PROPERTY_ATTRIBUTE_DELETE,
      payload: {
        propertyAttributeId,
      },
      onSuccess: onChange,
      onError: (err) => {
        global.alert(`Error: "${err.message}"`);
      },
    });
  };

  _onPropertyAttributeChange = () => {
    this._onClosePropertyAttributeModal();
    this.props.onChange();
  };

  render() {
    const { propertyAttributes } = this.props;

    return (
      <SrBox>
        <SrTable
          headers={[
            { content: 'id' },
            { content: 'apartment id' },
            { content: 'building id' },
            { content: 'floor plan id' },
            { content: 'behavior' },
            { content: 'name' },
            { content: 'value' },
            { content: 'options', width: 10 },
          ]}
          rows={propertyAttributes.map((propertyAttribute) => ({
            cells: [
              { content: propertyAttribute.id },
              {
                content:
                  !propertyAttribute.apartmentBuildingId && !propertyAttribute.floorPlanId
                    ? propertyAttribute.apartmentId
                    : '',
              },
              { content: propertyAttribute.apartmentBuildingId },
              { content: propertyAttribute.floorPlanId },
              { content: propertyAttribute.cascadingBehavior },
              { content: propertyAttribute.name },
              {
                content: isIsoDateString(propertyAttribute.attrs.value.toString())
                  ? momentWithAustinTimezone(propertyAttribute.attrs.value.toString()).format(
                      'MM/DD/YYYY',
                    )
                  : propertyAttribute.attrs.value.toString(),
              },
              {
                content: (
                  <div>
                    <SrBox display="inlineBlock" width={10} />
                    <SrText
                      cursor="pointer"
                      color="blue300"
                      data-id={propertyAttribute.id}
                      onClick={this._onDeletePropertyAttribute}
                    >
                      Delete
                    </SrText>
                  </div>
                ),
              },
            ],
          }))}
        />
      </SrBox>
    );
  }
}

export default SrTablePropertyAttributes;
